import { useComputedColorScheme, useMantineTheme } from '@mantine/core';

export const useProviderDashboardPalette = () => {
  const theme = useMantineTheme();
  const colorScheme = useComputedColorScheme('dark');
  const isDark = colorScheme === 'dark';

  return {
    isDark,
    cardBackground: isDark ? '#1B1F27' : theme.white,
    cardBorder: isDark
      ? 'rgba(96, 110, 133, 0.28)'
      : 'rgba(15, 23, 42, 0.08)',
    primaryText: isDark ? '#F5F7FB' : theme.colors.dark[7],
    secondaryText: isDark ? 'rgba(255,255,255,0.72)' : theme.colors.gray[7],
    mutedText: isDark ? 'rgba(255,255,255,0.58)' : theme.colors.gray[6],
    subtleText: isDark ? 'rgba(255,255,255,0.42)' : theme.colors.gray[6],
    divider: isDark ? 'rgba(255,255,255,0.08)' : 'rgba(15,23,42,0.08)',
    hintBorder: isDark ? 'rgba(255,255,255,0.2)' : 'rgba(15,23,42,0.16)',
    hintText: isDark ? 'rgba(255,255,255,0.52)' : theme.colors.gray[7],
    toggleBackground: isDark ? 'rgba(255,255,255,0.06)' : 'rgba(15,23,42,0.06)',
    toggleBorder: isDark ? 'rgba(255,255,255,0.12)' : 'rgba(15,23,42,0.1)',
    toggleShadow: isDark
      ? 'inset 0 1px 2px rgba(255, 255, 255, 0.08)'
      : 'inset 0 1px 2px rgba(15, 23, 42, 0.06)',
    toggleThumbBackground: isDark ? '#F5F7FB' : theme.white,
    toggleThumbText: isDark ? '#1B1F27' : theme.colors.dark[7],
    toggleInactiveText: isDark
      ? 'rgba(255,255,255,0.68)'
      : theme.colors.gray[7],
    revenueRangeBadgeBackground: isDark
      ? 'rgba(63, 127, 92, 0.45)'
      : 'rgba(74, 163, 116, 0.18)',
    revenueRangeBadgeText: isDark ? '#6AD5A7' : '#205C3A',
    summaryBadgeText: isDark ? '#F5F7FB' : theme.white,
  };
};
